(function fixCarouselSnap(){
  document.addEventListener('carousel:settle', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }

    if (e.detail && e.detail.index === 0 && el.classList.contains('peeking') && el.scrollLeft > 0) {
      el.scrollTo({ left: 0, behavior: 'auto' });
    }
  }, true);

  document.addEventListener('scrollend', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'SCROLL-CAROUSEL') return;

    if (el.style.scrollSnapType === 'none') {
      el.style.removeProperty('scroll-snap-type');
    }
  }, true);
})();

(function initCardSwatchArrows(){
  function setup(wrap){
    var track = wrap.querySelector('[data-card-swatches-track]');
    var prev = wrap.querySelector('[data-swatches-prev]');
    var next = wrap.querySelector('[data-swatches-next]');
    if (!track || !prev || !next) return;
    if (wrap.__swatchArrowsBound) return;
    wrap.__swatchArrowsBound = true;

    function getGap(){
      var gap = parseFloat(getComputedStyle(track).gap);
      return isFinite(gap) ? gap : 0;
    }

    function getUnit(){
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return 24;
      return swatch.getBoundingClientRect().width + getGap();
    }

    function clampWidth(){
      var swatch = track.querySelector('.color-swatch');
      if (!swatch) return;

      var gap = getGap();
      var swatchW = swatch.getBoundingClientRect().width;
      if (!swatchW) return; // not laid out yet; ResizeObserver will re-run

      var unit = swatchW + gap;
      var total = track.querySelectorAll('.color-swatch').length;
      var contentWidth = total * unit - gap;

      track.style.maxWidth = '';

      var wrapWidth = wrap.clientWidth;
      if (!wrapWidth) return;

      if (contentWidth <= wrapWidth + 0.5) return; // everything fits

      // Overflow: reserve the real arrow footprint (0 on mobile where
      // arrows are display:none), then clamp to a whole number of swatches.
      prev.classList.add('is-shown');
      next.classList.add('is-shown');
      var arrowSpace = prev.offsetWidth + next.offsetWidth;

      var available = wrapWidth - arrowSpace;
      var count = Math.floor((available + gap + 0.5) / unit);
      if (count < 1) count = 1;
      if (count > total) count = total;
      track.style.maxWidth = (count * unit - gap) + 'px';
    }

    function updateArrows(){
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;

      prev.classList.toggle('is-shown', hasOverflow);
      next.classList.toggle('is-shown', hasOverflow);
      prev.classList.toggle('is-visible', hasOverflow && !atStart);
      next.classList.toggle('is-visible', hasOverflow && !atEnd);
    }

    prev.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit - 1) * unit;
      track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    });

    next.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var unit = getUnit();
      var target = Math.round(track.scrollLeft / unit + 1) * unit;
      track.scrollTo({ left: Math.min(target, track.scrollWidth - track.clientWidth), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    clampWidth();
    updateArrows();

    var _resizeTimer;
    var card = wrap.closest('product-card') || wrap.closest('.product-card') || wrap.parentElement;
    new ResizeObserver(function(){
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(function(){
        clampWidth();
        updateArrows();
      }, 50);
    }).observe(card);
  }

  function init(){
    document.querySelectorAll('[data-card-swatches-wrap]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function(){
    document.querySelectorAll('[data-card-swatches-wrap]:not([data-bound])').forEach(function(w){
      w.setAttribute('data-bound', '');
      setup(w);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();


(function swatchSwipeHint(){
  if (!window.matchMedia || !matchMedia('(pointer: coarse)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var KEY = 'thg-swatch-swipe-hint';
  try {
    if (/[?&]swatch_hint=reset/.test(location.search)) localStorage.removeItem(KEY);
    if (localStorage.getItem(KEY)) return;
  } catch (_) { return; }

  var fired = false;

  function nudge(t){
    if (fired) return;
    fired = true;
    try { localStorage.setItem(KEY, '1'); } catch (_) {}
    var prevSnap = t.style.scrollSnapType;
    t.style.scrollSnapType = 'none';
    t.scrollTo({ left: 34, behavior: 'smooth' });
    setTimeout(function(){ t.scrollTo({ left: 0, behavior: 'smooth' }); }, 550);
    setTimeout(function(){ t.style.scrollSnapType = prevSnap; }, 1300);
  }

  var io = new IntersectionObserver(function(entries){
    if (fired) { io.disconnect(); return; }
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      var t = e.target;
      if (!e.isIntersecting || t.scrollWidth <= t.clientWidth + 4 || t.scrollLeft !== 0) continue;
      // Row must be FULLY visible vertically (user can actually see it),
      // but only >=30% horizontally so carousel peek cards still qualify.
      var r = e.boundingClientRect;
      var vh = (e.rootBounds && e.rootBounds.height) || window.innerHeight;
      var vw = (e.rootBounds && e.rootBounds.width) || window.innerWidth;
      var vertOk = r.top >= 0 && r.bottom <= vh;
      var horizRatio = (Math.min(r.right, vw) - Math.max(r.left, 0)) / r.width;
      if (vertOk && horizRatio >= 0.3) {
        io.disconnect();
        setTimeout(function(){ nudge(t); }, 600);
        return;
      }
    }
  }, { threshold: [0.1, 0.3, 0.6, 0.9] });

  function observeAll(){
    if (fired) return;
    document.querySelectorAll('[data-card-swatches-track]').forEach(function(t){
      io.observe(t);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeAll);
  else observeAll();
  window.addEventListener('load', observeAll);
})();
